import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import {
  ClearButton,
  CrossLine,
  Error,
  Input,
  Label,
  Wrapper,
  SwitchReadable,
  Icon,
} from './style';

const TextField = ({
  label,
  type,
  toggleable,
  icon,
  textSize,
  single,
  withStrengthBar,
  textarea,
  onChange,
  onClear,
  onIconClick,
  withClearButton,
  light,
  ...props
}) => {
  const [readableValue, setReadableValue] = useState(false);
  const [field, meta] = useField(props);

  const fieldId = `field_${field.name}`;
  const hasError = meta.touched && meta.error;

  let inputType = type;
  if (type === 'password' && toggleable) {
    inputType = readableValue ? 'text' : 'password';
  }

  const onChangeHandler = ev => {
    if (typeof onChange === 'function') {
      onChange(ev);
    }

    field.onChange(ev);
  };

  return (
    <Wrapper withError={hasError} single={single} light={light}>
      {label ? (
        <Label
          htmlFor={fieldId}
          filled={!!meta.value}
          withIcon={!!icon}
          light={light}
        >
          {label}
        </Label>
      ) : null}
      {type === 'password' && toggleable ? (
        <SwitchReadable
          type="button"
          onClick={() => setReadableValue(!readableValue)}
          readable={readableValue}
          tabIndex={-1}
        >
          <img src="/images/icons/eye.svg" alt="toggle" />
          <CrossLine />
        </SwitchReadable>
      ) : null}
      {icon ? (
        <Icon
          withLabel={!!label}
          src={`/images/icons/${icon}.svg`}
          alt=""
          onClick={onIconClick}
        />
      ) : null}

      <Input
        as={textarea ? 'textarea' : 'input'}
        id={fieldId}
        withError={hasError}
        withIcon={!!icon}
        type={inputType}
        textSize={textSize}
        light={light}
        {...field}
        {...props}
        onChange={onChangeHandler}
      />

      <ClearButton
        type="button"
        onClick={onClear}
        withIcon={!!icon}
        className={withClearButton ? 'visible' : null}
        tabIndex={-1}
      >
        <img src="/images/icons/cross.svg" alt="clear" />
      </ClearButton>

      {meta.touched && meta.error ? <Error>{meta.error}</Error> : null}
    </Wrapper>
  );
};

TextField.defaultProps = {
  label: null,
  type: 'text',
  autoFocus: false,
  toggleable: false,
  icon: null,
  textSize: 'large',
  single: false,
  withStrengthBar: false,
  textarea: false,
  onChange: null,
  withClearButton: false,
  onClear: null,
  onIconClick: null,
  light: false,
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'number', 'phone', 'password']),
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  toggleable: PropTypes.bool,
  icon: PropTypes.string,
  textSize: PropTypes.oneOf(['normal', 'large']),
  single: PropTypes.bool,
  withStrengthBar: PropTypes.bool,
  textarea: PropTypes.bool,
  onChange: PropTypes.func,
  withClearButton: PropTypes.bool,
  onClear: PropTypes.func,
  onIconClick: PropTypes.func,
  light: PropTypes.bool,
};

export default TextField;
